module.exports = __webpack_public_path__ + "static/media/img-keelo-quote@2x.9c31c5aa.png";